module.exports = __webpack_public_path__ + "img/NHaasGroteskTXPro-65Md.c6a2965.svg";